import { sendEmail } from "./sendEmail";

export const reportError = async(props) => {

    const { emailTo, values, task } = props;
    const result = await sendEmail({
        "toemail": emailTo,
        "subject": "ERROR - " + task,
        "message": values,
    });

    return result;
};
